import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import './Knowledge.css';

const categories = [
  { value: 'feed', label: 'Feed & Nutrition' },
  { value: 'shipping', label: 'Shipping & Delivery' },
  { value: 'ordering', label: 'Ordering & Pricing' },
  { value: 'animal_care', label: 'Animal Care' },
  { value: 'farmhand', label: 'Farmhand App Help' },
  { value: 'policies', label: 'Policies & Procedures' },
  { value: 'products', label: 'Product Information' },
  { value: 'troubleshooting', label: 'Troubleshooting' },
  { value: 'general', label: 'General' },
];

const NewArticle: React.FC = () => {
  const navigate = useNavigate();
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [category, setCategory] = useState('general');
  const [keywords, setKeywords] = useState('');
  const [answeredBy, setAnsweredBy] = useState('both');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!question.trim() || !answer.trim()) {
      setError('Question and answer are required');
      return;
    }

    setSaving(true);
    setError('');

    try {
      await api.post('/knowledge/articles/', {
        question: question.trim(),
        answer: answer.trim(),
        category,
        keywords: keywords.trim(),
        answered_by: answeredBy,
      });
      navigate('/knowledge/articles');
    } catch (err: any) {
      console.error('Error creating article:', err);
      setError(err.response?.data?.detail || 'Error creating article');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="knowledge-container">
      <div className="knowledge-header">
        <div className="header-left">
          <Link to="/knowledge/articles" className="back-link">&larr; Articles</Link>
          <h1>New Knowledge Article</h1>
          <p className="knowledge-subtitle">Add a new Q&A for Hank & Laura</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="article-form">
        {error && <div className="form-error">{error}</div>}

        <div className="form-group">
          <label htmlFor="question">Question *</label>
          <input
            type="text"
            id="question"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="What question does this answer?"
            required
          />
          <span className="form-hint">Write the question as a customer might ask it</span>
        </div>

        <div className="form-group">
          <label htmlFor="answer">Answer *</label>
          <textarea
            id="answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            placeholder="The answer Hank or Laura should give..."
            rows={6}
            required
          />
          <span className="form-hint">Write in the friendly tone of Red Bridge Farm</span>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="category">Category</label>
            <select
              id="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {categories.map(c => (
                <option key={c.value} value={c.value}>{c.label}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="answeredBy">Who should answer?</label>
            <select
              id="answeredBy"
              value={answeredBy}
              onChange={(e) => setAnsweredBy(e.target.value)}
            >
              <option value="both">Either Hank or Laura</option>
              <option value="hank">Hank (farming/feed expert)</option>
              <option value="laura">Laura (data/logistics)</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="keywords">Keywords</label>
          <input
            type="text"
            id="keywords"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
            placeholder="e.g., layer feed, winter feeding, protein content"
          />
          <span className="form-hint">Comma-separated keywords to help AI find this article</span>
        </div>

        <div className="form-actions">
          <button
            type="submit"
            disabled={saving}
            className="btn-action btn-green"
          >
            {saving ? 'Saving...' : 'Create Article'}
          </button>
          <Link to="/knowledge/articles" className="btn-action btn-gray">
            Cancel
          </Link>
        </div>
      </form>
    </div>
  );
};

export default NewArticle;
